import type { AgentTemplateKind } from './types';

/** User-facing kind labels (design §28, audit #8 — sentence case). */
export const AGENT_TEMPLATE_KIND_LABELS: Record<AgentTemplateKind, string> = {
  'org-manager': 'Org manager',
  assistant: 'Assistant',
  'audio-assistant': 'Audio assistant',
  coder: 'Coder',
  custom: 'Custom',
};

export function kindLabel(kind: string | undefined): string {
  if (kind && kind in AGENT_TEMPLATE_KIND_LABELS) {
    return AGENT_TEMPLATE_KIND_LABELS[kind as AgentTemplateKind];
  }
  return kind ?? 'Custom';
}
